var _defs, _g, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pressure") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#e59222;}.c{fill:#c77d00;}.d,.e{stroke:none;}.e{fill:#e59222;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M9.5,0A9.5,9.5,0,1,1,0,9.5,9.5,9.5,0,0,1,9.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 9.5 1 C 4.813079833984375 1 1 4.813079833984375 1 9.5 C 1 14.18692016601562 4.813079833984375 18 9.5 18 C 14.18692016601562 18 18 14.18692016601562 18 9.5 C 18 4.813079833984375 14.18692016601562 1 9.5 1 M 9.5 0 C 14.74670028686523 0 19 4.253299713134766 19 9.5 C 19 14.74670028686523 14.74670028686523 19 9.5 19 C 4.253299713134766 19 0 14.74670028686523 0 9.5 C 0 4.253299713134766 4.253299713134766 0 9.5 0 Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.157,0V0l-3.4,2.177A3.5,3.5,0,0,1,10.095,5.8l2.738,2.925A7.489,7.489,0,0,0,14.159,0ZM.81.07h0A7.388,7.388,0,0,0,0,3.453a7.472,7.472,0,0,0,2.009,5.1L4.756,5.621A3.453,3.453,0,0,1,4,3.453a3.556,3.556,0,0,1,.171-1.08H4.109L.811.07ZM5.126,6.021h0L2.4,8.947A7.488,7.488,0,0,0,12.43,9.1L9.7,6.169a3.492,3.492,0,0,1-4.576-.147Z",
    transform: "translate(17 12.953) rotate(180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.5,8.688C2.328,8.688,3,2.328,3,1.5a1.5,1.5,0,0,0-3,0C0,2.328.672,8.688,1.5,8.688Z",
    transform: "matrix(-0.574, -0.819, 0.819, -0.574, 8.802, 16.377)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(9 14)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressure);
export default __webpack_public_path__ + "static/media/pressure.c6965431d306264f5cefa317b8f95e46.svg";
export { ForwardRef as ReactComponent };